<template>
  <div class="catalog-item-create">
    <md-dialog :md-active.sync="dialogVisible" :md-click-outside-to-close="false" class="catalog-item-create__modal">

      <md-dialog-content>
        <md-button @click="closeDialog()" class="md-icon-button catalog-item-create__button--close">
          <md-icon>close</md-icon>
        </md-button>

        <h3 class="catalog-item-create__title">Neue Kategorie</h3>
        <div class="catalog-item-create__content">
          <form class="md-layout" @submit.prevent="submit">
            <md-field required>
              <label for="name">Bezeichnung</label>
              <md-input name="name" id="name" required v-model="item.name"/>
            </md-field>
            <div class="catalog-item-create__buttons">
              <button type="submit" :disabled="!validated" class="button catalog-item-create__button catalog-item-create__button--add">Hinzufügen</button>
            </div>

          </form>
        </div>
      </md-dialog-content>
    </md-dialog>
  </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'

    export default {
        name: 'CatalogItemCreate',
        data() {
            return {
                showDialog: true,
                showIconDialog: false,
                showSnackbar: false,
                snackbarMessage: 'Erfolgreich erstellt.',
                item: {
                    name: null
                }
            }
        },
        computed: {
            ...mapGetters('auth', [
                'user'
            ]),
            ...mapGetters('catalog', [
                'showCreateCategory'
            ]),
            validated: function () {
                return this.item.name
            },
            dialogVisible: function() {
                return this.showCreateCategory && this.showDialog
            }
        },
        mounted() {
            this.item.location_id = this.user.locationId
            this.showDialog = true
        },
        methods: {
            ...mapActions('dashboard', [
                'loadLocation'
            ]),
            ...mapActions('catalog', [
                'createCategory',
                'showCreateCategoryForm'
            ]),
            closeDialog: function() {
                this.showCreateCategoryForm(false)
            },
            submit: async function() {
                let payload = {
                    item: this.item,
                    locationId: this.user.locationId
                }
                await this.createCategory(payload)
                this.showSnackbar = true
                this.showDialog = false

                // reset input
                this.item.name = null
            }
        }
    }
</script>